<div class="action remove" (click)="onDeleteClicked()">
    <ion-icon mode="ios" name="trash"></ion-icon>
</div>